import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;
import styled, { css } from 'styled-components';
import Column from '../Column/Column';
import { withTheme } from '../../core/ThemeProvider';
import Config from '../../config';
import { CARD_CAROUSEL_PADDING } from './CarouselSwimlane';
export var Wrapper = styled.div.withConfig({
  displayName: "style__Wrapper",
  componentId: "sc-f0u8oe-0"
})(["width:100%;display:flex;position:relative;"]);
export var CarouselWrapper = withTheme(styled.div.withConfig({
  displayName: "style__CarouselWrapper",
  componentId: "sc-f0u8oe-1"
})(function (props) {
  return css(["scroll-behavior:smooth;transition:transform 0.8s ease;width:100%;overflow:", ";", ";scrollbar-width:none;::-webkit-scrollbar{display:none;}border-radius:", ";"], props.type === 'card' ? 'scroll' : 'hidden', Config.media.sm(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        overflow: hidden;\n      "]))), props.type === 'image' && !props.fullWidth && "".concat(props.coreTheme.rad_xl));
}));
export var CarouselContainer = styled.div.withConfig({
  displayName: "style__CarouselContainer",
  componentId: "sc-f0u8oe-2"
})(["display:flex;padding:", ";transition:transform 0.8s ease;transform:", ";", ";"], function (props) {
  return props.type === 'card' && "".concat(CARD_CAROUSEL_PADDING, "px");
}, function (props) {
  return props.type === 'card' ? 'none' : "translateX(-".concat(props.current * 100, "%)");
}, Config.media.sm(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    transform: ", ";\n    "])), function (props) {
  return "translateX(-".concat(props.current * 100, "%)");
}));
export var CarouselSlot = styled.div.withConfig({
  displayName: "style__CarouselSlot",
  componentId: "sc-f0u8oe-3"
})(["margin-right:", ";&:last-child{padding-right:", ";", "}width:", ";flex-shrink:0;"], function (props) {
  return props.type === 'card' && '16px';
}, function (props) {
  return props.type === 'card' && '15px';
}, Config.media.sm(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      padding-right: ", "px;\n    "])), CARD_CAROUSEL_PADDING), function (props) {
  return props.type === 'image' ? '100%' : 'fit-content';
});
var Overlay = styled(Column).withConfig({
  displayName: "style__Overlay",
  componentId: "sc-f0u8oe-4"
})(["position:absolute;z-index:2;width:100%;height:100%;padding:", "px 0;display:none;", ";"], CARD_CAROUSEL_PADDING, Config.media.sm(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    display: block;\n  "]))));
export var ArrowButton = withTheme(styled.div.withConfig({
  displayName: "style__ArrowButton",
  componentId: "sc-f0u8oe-5"
})(function (props) {
  return css(["display:none;", ";visibility:", ";position:", ";cursor:pointer;width:40px;height:40px;align-items:center;justify-content:center;border-radius:100%;background-color:", ";z-index:", ";top:", ";transform:", ";opacity:", ";", ";", ";"], Config.media.sm(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n        display: flex;\n      "]))), props.showArrow ? 'visible' : 'hidden', props.position || props.inside && 'absolute', props.coreTheme.cl_ter_l5, props.inside && '10', props.inside && '50%', props.inside && 'translateY(-50%)', props.inside && '1', props.inside && props.left && 'left: calc(2.8% + 1px);', props.inside && props.right && 'right: calc(2.8% + 1px);');
}));
export var ArrowButtonContainer = styled.div.withConfig({
  displayName: "style__ArrowButtonContainer",
  componentId: "sc-f0u8oe-6"
})(["height:100%;display:flex;justify-content:center;background-color:rgba(247,247,247,0.5);"]);
export var LeftArrowOverlay = styled(Overlay).withConfig({
  displayName: "style__LeftArrowOverlay",
  componentId: "sc-f0u8oe-7"
})(["left:0;display:none;visibility:hidden;", ";"], Config.media.sm(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    display: block;\n    visibility: ", ";\n  "])), function (props) {
  return props.showArrow ? 'visible' : 'hidden';
}));
export var RightArrowOverlay = styled(Overlay).withConfig({
  displayName: "style__RightArrowOverlay",
  componentId: "sc-f0u8oe-8"
})(["right:0;display:none;visibility:hidden;", ";"], Config.media.sm(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    display: block;\n    visibility: ", ";\n  "])), function (props) {
  return props.showArrow ? 'visible' : 'hidden';
}));
export var OutsideArrowButtonWrapper = styled.div.withConfig({
  displayName: "style__OutsideArrowButtonWrapper",
  componentId: "sc-f0u8oe-9"
})(["display:none;", ";"], Config.media.sm(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    position: absolute;\n    display: flex;\n    width: 40px;\n    align-items: center;\n    ", "\n    ", "\n  "])), function (props) {
  return props.left && 'margin-right: 14px; left: 0;';
}, function (props) {
  return props.right && 'margin-left: 14px; left: 0;';
}));
export var PaginationPanel = styled.div.withConfig({
  displayName: "style__PaginationPanel",
  componentId: "sc-f0u8oe-10"
})(["display:", ";align-items:center;justify-content:center;margin-top:8px;", ";"], function (props) {
  return props.type === 'card' ? 'none' : 'flex';
}, Config.media.sm(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    display: flex;\n    margin-top: 16px;\n  "]))));
export var PaginationDot = withTheme(styled.div.withConfig({
  displayName: "style__PaginationDot",
  componentId: "sc-f0u8oe-11"
})(function (props) {
  return css(["cursor:pointer;width:", ";height:8px;", " margin:0 6px;border-radius:", ";background:", ";vertical-align:", ";"], props.active ? '24px' : '8px', Config.media.sm(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n        width: ", ";\n        height: 12px;\n      "])), props.active ? '36px' : '12px'), props.active ? '15px' : '100%', props.active ? "".concat(props.coreTheme.cl_ter_l3) : "".concat(props.coreTheme.cl_ter_l5), props.active ? 'text-top' : 'unset');
}));